import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';

@Injectable()
export class NoStudyGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (!localStorage.getItem('study')) {
      return true;
    }

    this.router.navigate(['/input']);
    return false;
  }
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/guards/no-study.guard.ts